import { render, staticRenderFns } from "./JSON.vue?vue&type=template&id=35a325d6"
import script from "./JSON.vue?vue&type=script&lang=js"
export * from "./JSON.vue?vue&type=script&lang=js"
import style0 from "./JSON.vue?vue&type=style&index=0&id=35a325d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports